import React, { Fragment, ReactNode, useEffect } from "react";

type Props = {
  children?: ReactNode;
  title?: string;
};

export const Document = ({ children, title }: Props) => {
  useEffect(() => {
    const originalTitle = document.title;

    if (title) {
      document.title = title;
    }

    // Return document title to default on component unmount
    return () => {
      document.title = originalTitle;
    };
  }, [title]);

  return <Fragment>{children || null}</Fragment>;
};
